<header>
    <mat-toolbar>
        <app-notifications></app-notifications>
        <button (click)="open()" mat-icon-button [disableRipple]="true" class="example-icon user-icon" aria-label="Example icon-button with share icon"
            (click)="stopPropagation($event)">
            <mat-icon>account_circle</mat-icon>
        </button>
    </mat-toolbar>
</header>

<ng-template #logoutDialog>
  <div class="delete-dialog bind-quote-dialog">
    <p mat-dialog-title>Confirm Logout</p>
    <div mat-dialog-content style="max-height: 350px;">
      <p>Are you sure you want to <strong>logout</strong> ?</p>
    </div>
    <div mat-dialog-actions style="justify-content: flex-end;padding-right: 30px;">
      <button mat-button class="secondary-btn-action" mat-dialog-close (click)="closeLogoutDialog()">Cancel</button>
      <button mat-button class="primary-btn-action" (click)="confirmLogoutAction()">Confirm</button>
    </div>
  </div>
</ng-template>

<mat-sidenav-container class="header-container" (backdropClick)="close()">
    <mat-sidenav #sidenav id="account-sidenav" (keydown.escape)="close()" disableClose>
        <div class="account-actions">
            <div class="account-actions-buttons">
                <button mat-stroked-button [disableRipple]="true" (click)="navigateToSettings()" aria-label="Open Settings">
                    <mat-icon>settings</mat-icon>
                    Settings
                </button>
                <button *ngIf="userConsent" class="termly-display-preferences" mat-stroked-button [disableRipple]="true" aria-label="Edit Cookie Preferences">
                    <mat-icon>cookie</mat-icon>
                    Edit Cookie Preferences
                </button>
                <button mat-stroked-button [disableRipple]="true" (click)="confirmLogout()" aria-label="Logout">
                    <mat-icon>logout</mat-icon>
                    Logout
                </button>
            </div>
        </div>
    </mat-sidenav>
</mat-sidenav-container>